import { useEffect, useState } from "react";
import { authHeaders } from "../lib/api";
import { env } from "../lib/env";
import { useProposal } from "../hooks/slice-a";

type Alert = { id: string; received_at: string; suburb: string | null; raw_brief: string | null; contact_hint: { name?: string; phone?: string }; channel_signals: { response: { version: number; owner_user_id: string; fallback_user_id: string } } };
/** Mounted above every CRM page: all signed-in sessions see the same ownership. */
export function LeadAlerts() {
  const [leads, setLeads] = useState<Alert[]>([]);
  const [error, setError] = useState("");
  const proposal = useProposal();
  useEffect(() => {
    if (env.mock) return;
    let live = true, running = false;
    const refresh = async () => {
      if (running) return; running = true;
      try {
        const r = await fetch(`${env.apiBase}/api/lead-alerts`, { headers: await authHeaders() });
        if (!r.ok) throw new Error("Lead alerts could not refresh. Check the lead inbox.");
        const j = await r.json(); if (live) { setLeads(j.data ?? []); setError(""); }
      } catch (e) { if (live) setError((e as Error).message); } finally { running = false; }
    };
    void refresh(); const timer = setInterval(() => { void refresh(); }, 5000);
    window.addEventListener("focus", refresh);
    return () => { live = false; clearInterval(timer); window.removeEventListener("focus", refresh); };
  }, [proposal.note?.at]);
  if (!leads.length && !error && !proposal.note) return null;
  return <section aria-label="Urgent customer calls" aria-live="polite" className="max-h-64 shrink-0 overflow-auto border-b bg-card px-4 py-3 text-sm">
    {error && <p role="status">{error}</p>}
    {proposal.note && <p role="status">{proposal.note.text}</p>}
    {leads.map(l => <article key={l.id} className="flex flex-wrap items-center gap-3 py-2">
      <div className="min-w-0 flex-1"><strong>Call customer — {l.contact_hint?.name || "New HiPages lead"}</strong><p>{l.suburb} · Arrange onsite measurement</p>
        {l.contact_hint?.phone && <a className="underline" href={`tel:${l.contact_hint.phone.replace(/[^+\d]/g, "")}`}>{l.contact_hint.phone}</a>}
      </div>
      <button type="button" className="rounded border px-3 py-2" disabled={proposal.busy} onClick={() => void proposal.run("respond_to_lead", {lead_id:l.id,action:"claim",version:l.channel_signals.response.version}, "You are handling this call")}>I’ll call</button>
      {l.channel_signals.response.owner_user_id !== l.channel_signals.response.fallback_user_id && <button type="button" className="rounded border px-3 py-2" disabled={proposal.busy} onClick={() => void proposal.run("respond_to_lead", {lead_id:l.id,action:"handoff",version:l.channel_signals.response.version}, "Passed to Jessie")}>Busy — pass to Jessie</button>}
      <a className="underline" href={`/leads?lead=${l.id}`}>Open lead</a>
    </article>)}
  </section>;
}
